import React, { Component } from 'react'
import Footer from '../Component/Footer'
import Header from '../Component/Header'
import Menu from '../Component/Menu'
import ItemsDataTable from './ItemsDataTable'

export default class inv extends Component {
    render() {
        return (
            <div>
                <Header />
                 <Menu/>
                <>
              <div className="content-wrapper">
              <ItemsDataTable/>

              </div>
              </>
              <Footer/>

            </div>
        )
    }
}
